import ModelService from './model.service';

const TokensBalanceService = new ModelService(
  '/companies/:company_id/tokens-balance',
  '/users/companies/:company_id/tokens-balance',
  'companies'
);

TokensBalanceService.getCompanyRoute = () => {
  return window.location.pathname.split("/").slice(0,-1).join('/');
};

TokensBalanceService.TYPE_ADMIN = 1;
TokensBalanceService.TYPE_SPENDING = 2;

TokensBalanceService.getTypeList = t => ({
  [TokensBalanceService.TYPE_ADMIN]: t('Admin user'),
  [TokensBalanceService.TYPE_SPENDING]: t('Spending by user'),
});

TokensBalanceService.getTypeOptions = t => TokensBalanceService
  .prepareOptionsFromSimpleObject(TokensBalanceService.getTypeList(t));

TokensBalanceService.getColorByType = (status) => {
  switch (status) {
    case TokensBalanceService.TYPE_ADMIN:
      return 'warning';
    case TokensBalanceService.TYPE_SPENDING:
      return 'danger';
    default:
      return 'secondary';
  }
};

TokensBalanceService.getTypeTitle = (status, t) => {
  const label = TokensBalanceService.getTypeList(t)[status];
  return label || '-';
};

export default TokensBalanceService;



// WEBPACK FOOTER //
// ./src/services/tokens-balance.service.js